import * as PIXI from "pixi.js";
import Layers from "../../src/layers/Layers";
import { rootEventBus, EnumRootEventBus } from "../managers/RootEventBus";
import Line from "./Line/Line";
import { Coord } from "../../src/types/Interface";
import drawSegments from "../../src/drawHelpers/drawSegments";
import OpacityAnimation from "../animation/OpacityAnimation";


export default class BaseSegmentChord {
  private Layers = Layers.getInstance();
  private isShownSegment: boolean = false;
  private line = new Line({color: 0xFF0000, width: 6});
  private segments!: PIXI.Graphics[];
  private cCoord!: Coord;
  
  constructor(cCoord: Coord){
    this.cCoord = cCoord;
  	this.addSegments();
  }
  handleSegmentVisible(v: boolean){
    this.isShownSegment = v;
    this.segmentVisibleWithAnimated(v);
  }
  segmentVisibleWithAnimated(v: boolean){
    const sOpacity = v ? 0 : 1;
    const tOpacity = v ? 1 : 0;
    const duration = 100;
    const elms = [this.line, ...this.segments];
    elms.forEach(elm => elm.alpha = sOpacity);

    rootEventBus.emit(EnumRootEventBus.drawElements);

    elms.forEach(elm => new OpacityAnimation(elm, sOpacity, tOpacity, duration, () => !v ? elm.clear() : ""));
  }
  addSegments(){
    this.segments = Array(2).fill("").map(_ => new PIXI.Graphics());
    this.Layers.BottomUnder.addChild(...this.segments);
  }

  draw(radius: number, radians: number[], [sCoord, eCoord]: Coord[], clockwise: boolean){
    if(!this.isShownSegment) return

    this.line.draw(sCoord, eCoord);
    drawSegments(this.segments, this.cCoord, radius, radians, clockwise);
  }
  clearAll(){
    this.segments.forEach(s => s.clear());
    this.line.clear();
  }
}